import { defineMessages } from 'react-intl';

export default function initSeasons() {
  defineMessages({
    season_spring: {
      id: 'season.spring',
      defaultMessage: 'Spring',
    },
    season_summer: {
      id: 'season.summer',
      defaultMessage: 'Summer',
    },
    season_autumn: {
      id: 'season.autumn',
      defaultMessage: 'Autumn',
    },
    season_winter: {
      id: 'season.winter',
      defaultMessage: 'Winter',
    },
  });
}
